<mat-card>
    <mat-card-header>
      <mat-card-title>Búsqueda de {{'Cuenta' | translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
  
      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
        <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
      </div>

        <ng-container *ngIf="canView">

            <mat-expansion-panel *ngIf="!isValidating">
    
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <form [formGroup]="searchForm">

                    <div fxLayout="row stretch" fxLayout.xs="column">

                        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                            <mat-form-field appearance="outline" style="width: 100%">
                                <mat-label class="text-style">Alias</mat-label>
                                <input class="text-style" matInput formControlName="Alias" (keyup.enter)="onSearch()">
                                <mat-icon matSuffix>search</mat-icon>
                            </mat-form-field>
                        </div>
                        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                            <mat-form-field appearance="outline" style="width: 100%">
                                <mat-label class="text-style">CBU/CVU</mat-label>
                                <input class="text-style" matInput formControlName="ClaveBancaria" (keyup.enter)="onSearch()">
                                <mat-icon matSuffix>search</mat-icon>
                            </mat-form-field>
                        </div>

                        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                            <mat-form-field appearance="outline" style="width: 100%">
                                <mat-label class="text-style">Banco</mat-label>
                                <mat-select class="text-style" formControlName="BancoId">
                                    <mat-option class="text-style">Ninguno</mat-option>
                                    <mat-option class="text-style" *ngFor="let s of bancosList" [value]="s.Id">{{s.Nombre}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                            <mat-form-field appearance="outline" style="width: 100%">
                                <mat-label class="text-style">Moneda</mat-label>
                                <mat-select class="text-style" formControlName="MonedaId">
                                    <mat-option class="text-style">Ninguna</mat-option>
                                    <mat-option class="text-style" *ngFor="let s of monedasList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                            <mat-form-field appearance="outline" style="width: 100%">
                                <mat-label class="text-style">Titular</mat-label>
                                <input class="text-style" matInput formControlName="Titular" (keyup.enter)="onSearch()">
                                <mat-icon matSuffix>search</mat-icon>
                            </mat-form-field>
                        </div>

                    </div>

                </form>

                <div fxLayout="row stretch" fxLayout.xs="column">
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                        <mat-checkbox [(ngModel)]="verSoloActivos" (keyup.enter)="onSearch()" color="primary">Ver Solo Activos</mat-checkbox> 
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                        <mat-checkbox [(ngModel)]="verSoloCuentaCorrienteInterna" (keyup.enter)="onSearch()" color="primary">Ver Solo Cuentas Internas</mat-checkbox> 
                    </div>
                </div>

            </mat-expansion-panel>

            <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px">
                <button mat-raised-button (click)="add()" *ngIf="canAdd" [disabled]="isSearching" color="accent" class="zb-button">Agregar</button>
                <button mat-raised-button (click)="onSearch()" [disabled]="isSearching" color="primary" class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
                <button mat-raised-button (click)="onExport()" [disabled]="isExporting" color="warn" class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar'}}</button>
            </div>

            <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
                <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
            </div>

            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching">
                <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' 
                    [pageSettings]='pageSettings' [allowResizing]='true' (actionFailure)="onGridActionFailure($event)">
                    <e-columns>
                        <e-column field='Propietario' headerText='Propietario' width=90></e-column>
                        <e-column field='Tipo' headerText='Tipo' width=90></e-column>
                        <e-column field='Codigo' headerText='Código' width=120></e-column>
                        <e-column field='ClaveBancaria' headerText='CBU/CVU' width=120></e-column>
                        <e-column field='Alias' headerText='Alias' width=120></e-column>
                        <e-column field='BancoNombre' headerText='Banco' width=90></e-column>
                        <e-column field='MonedaCodigo' headerText='Moneda' width=90></e-column>
                        <!-- <e-column field='SaldoDisponible' headerText='Saldo' width=90 format="N2"></e-column> -->
                        <e-column field='EsCuentaCorrienteInterna' headerText='Cuenta Interna?' *ngIf="canTenantAdmin" width=90>
                            <ng-template #template let-data>
                                {{data.EsCuentaCorrienteInterna ? 'Sí' : 'No'}}
                            </ng-template>
                        </e-column>
                        <e-column headerText='Acciones' width=90>
                            <ng-template #template let-data>
                                <a style="cursor: pointer; margin-right: 5px" (click)="edit(data)"><i class="fa fa-eye fa-1x"></i></a>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>

        </ng-container>

    </mat-card-content>
</mat-card>